import { Box, Container, TextField, Typography } from '@mui/material'
import React from 'react'
import CustomerStatus from './StatusBar'
import { ecommerceInterface } from '@cbgms/api/modules/customers'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles({
  container: {
    overflow: 'auto',
    height: '330px'
  },
  box: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '8px'
  },
  title: {
    alignSelf: 'flex-start',
    fontSize: '20px',
    padding: '0px',
    margin: '0px'
  },
  textField: {
    width: '100%',
    margin: 'normal'
  }
})

const EcommerceInfo: React.FC<{ eData: ecommerceInterface }> = ({ eData }) => {
  const { t } = useTranslation()
  const classes = useStyles()

  return !eData.EmailId ? (
    <Container className={classes.container}>
      <Typography>Package Not Requested</Typography>
    </Container>
  ) : (
    <Container className={classes.container}>
      <Box>
        <CustomerStatus eData={eData} />
      </Box>

      <Box className={classes.box}>
        <p className={classes.title}>{t('PopUps.AdminData')}</p>

        <TextField
          InputProps={{
            readOnly: true
          }}
          aria-readonly
          label='Auth0 ID'
          type='input'
          variant='outlined'
          fullWidth
          margin='normal'
          value={eData.Auth0Id}
          size='small'
          className={classes.textField}
        />
        <TextField
          label={t('PopUps.EmailID')}
          type='input'
          variant='outlined'
          fullWidth
          margin='normal'
          InputLabelProps={{ shrink: true }}
          value={eData.EmailId}
          aria-readonly
          InputProps={{
            readOnly: true
          }}
          size='small'
          className={classes.textField}
        />
        <TextField
          label={t('PopUps.DateofCreation')}
          type='input'
          variant='outlined'
          fullWidth
          margin='normal'
          InputLabelProps={{ shrink: true }}
          value={eData.CreationDate}
          aria-readonly
          InputProps={{
            readOnly: true
          }}
          size='small'
          className={classes.textField}
        />
      </Box>
    </Container>
  )
}

export default EcommerceInfo
